<template>
  <div class="detail-page-shell">
    <div class="detail-page-shell__header" :class="{ 'detail-page-shell__header--compact': compactHeader }">
      <div class="detail-page-shell__main">
        <el-button
          v-if="backTo || useHistoryBack"
          type="text"
          icon="el-icon-arrow-left"
          class="detail-page-shell__back"
          @click="onBackClick"
        >
          {{ backText || $t('common.back') }}
        </el-button>
        <div v-if="!compactHeader" class="detail-page-shell__titles">
          <div class="detail-page-shell__headline">
            <h1 class="detail-page-shell__title">{{ title }}</h1>
            <el-tag v-if="statusText" :type="statusType" effect="plain" size="small">
              {{ statusText }}
            </el-tag>
          </div>
          <p v-if="subtitle" class="detail-page-shell__subtitle">{{ subtitle }}</p>
          <div v-if="$slots.meta" class="detail-page-shell__meta">
            <slot name="meta" />
          </div>
        </div>
      </div>
      <div v-if="$slots.actions" class="detail-page-shell__actions">
        <slot name="actions" />
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'DetailPageShell',
  props: {
    /** 无大标题区时可为空（与 compactHeader 联用） */
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    backTo: { type: String, default: '' },
    /** 为 true 时点击返回走 $router.back()，回到进入本页前的页面 */
    useHistoryBack: { type: Boolean, default: false },
    backText: { type: String, default: '' },
    statusText: { type: String, default: '' },
    statusType: { type: String, default: 'info' },
    /** 为 true 时只显示返回与操作区，不渲染标题/副标题/状态/meta */
    compactHeader: { type: Boolean, default: false }
  },
  methods: {
    onBackClick() {
      if (this.useHistoryBack) {
        this.$router.back()
        return
      }
      if (this.backTo) this.$router.push(this.backTo)
    }
  }
}
</script>

<style scoped>
.detail-page-shell {
  padding: 24px 28px 36px;
}

.detail-page-shell__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.detail-page-shell__header--compact {
  align-items: center;
  margin-bottom: 12px;
}

.detail-page-shell__main {
  min-width: 0;
  flex: 1;
}

.detail-page-shell__back {
  margin-bottom: 6px;
  padding-left: 0;
}

.detail-page-shell__header--compact .detail-page-shell__back {
  margin-bottom: 0;
}

.detail-page-shell__headline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.detail-page-shell__title {
  margin: 0;
  color: var(--color-text);
  font-size: 24px;
  font-weight: 700;
}

.detail-page-shell__subtitle {
  margin: 8px 0 0;
  color: var(--color-text-sub);
  line-height: 1.6;
  font-size: 13px;
}

.detail-page-shell__meta {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  color: var(--color-text-sub);
  font-size: 12.5px;
}

.detail-page-shell__actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}

@media (max-width: 900px) {
  .detail-page-shell {
    padding: 18px 16px 28px;
  }

  .detail-page-shell__header {
    flex-direction: column;
  }

  .detail-page-shell__actions {
    justify-content: flex-start;
  }
}
</style>
